<app-content-container data-testid="dashboard">
  <div class="mb-7">
    <app-banner-card padding="32px 0 0 0" [header]="('shared.hello' | translate) + ' ' + currentDbUser$?.name" />
  </div>

  <div class="flex mt-4 rounded-2xl gap-6 p-6 bg-shikenso-gray-base">
    <div class="flex-none w-fit">
      <app-dashboard-calendar
        [campaigns]="campaignsStore.campaigns$()"
        [selectedDate]="selectedDate()"
        [selectedMonth]="selectedMonth()"
        [loadingCampaigns]="campaignsStore.loading$()"
        (dateSelected)="onDateSelected($event)"
        (monthChanged)="onMonthChanged($event)"
      />
    </div>

    <div class="w-px bg-shikenso-purple-base-12 -my-6"></div>

    <div class="flex-1 min-w-0">
      <app-dashboard-campaigns
        [campaigns]="campaignsStore.campaigns$()"
        [selectedDate]="selectedDate()"
        [campaignAnalyticsMap]="store.campaignAnalyticsMap$()"
        [loadingCampaigns]="campaignsStore.loading$()"
        [loadingCampaignAnalytics]="store.loadingAnalytics$()"
      />
    </div>
  </div>
</app-content-container>
